import { createAction } from 'redux-actions';

export const FETCH_INVOICES = 'invoices/fetch';
export const FETCH_INVOICES_SUCCESSFUL = 'invoices/fetchSuccessful';
export const FETCH_INVOICES_FAILED = 'invoices/fetchSuccess';

export const invoiceActionCreators = {
  fetchInvoices: createAction(FETCH_INVOICES),
};
